import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  /** @type {number | undefined} */
  #openAnimationFrame;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    if (this.#openAnimationFrame) cancelAnimationFrame(this.#openAnimationFrame);
  }

  /**
   * Opens the drawer after the cart UI has rendered a successful product addition.
   * @param {CartAddEvent} event
   */
  #handleCartAdd = (event) => {
    if (
      !this.hasAttribute('auto-open') ||
      event.detail.data?.source !== 'product-form-component' ||
      event.detail.data?.didError
    ) {
      return;
    }

    this.#openAnimationFrame = requestAnimationFrame(() => {
      this.#openAnimationFrame = undefined;
      this.open();
    });
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
